var _rect, _path, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnLargeLightbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 76,
    viewBox: "0 0 249 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 235,
    height: 62,
    rx: 31,
    fill: "url(#paint0_linear_968_11135)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.7734 49.48C98.2734 49.48 101.603 46.69 101.603 42.97C101.603 35.86 90.2334 37.54 90.2334 33.4C90.2334 31.93 91.6734 30.91 93.2634 30.91C95.2134 30.91 96.6234 32.41 96.6234 34.27L100.763 33.97C100.763 30.28 97.5834 27.52 93.3534 27.52C89.1534 27.52 86.0934 29.98 86.0934 33.34C86.0934 40.3 97.4634 38.83 97.4634 43.27C97.4634 44.89 95.9034 46.09 93.7734 46.09C91.0134 46.09 89.0934 43.93 89.0934 40.81L84.9234 41.11C84.9234 45.61 88.5234 49.48 93.7734 49.48ZM105.356 49H119.396V45.61H109.496V39.79H117.596V36.4H109.496V31.39H119.396V28H105.356V49ZM123.446 49H127.616V34.33L136.856 49H141.326V28H137.156V42.67L127.916 28H123.446V49ZM146.283 49H153.183C160.023 49 163.623 45.4 163.623 38.5C163.623 31.6 160.023 28 153.183 28H146.283V49ZM150.423 45.61V31.39H153.183C157.683 31.39 159.483 33.43 159.483 38.5C159.483 43.57 157.683 45.61 153.183 45.61H150.423Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 245,
    height: 72,
    rx: 36,
    stroke: "url(#paint1_linear_968_11135)",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_968_11135",
    x1: 7,
    y1: 7,
    x2: 211.585,
    y2: 122.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B1EED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_968_11135",
    x1: 2,
    y1: 2,
    x2: 225.822,
    y2: 115.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B1EED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnLargeLightbutton);
export default __webpack_public_path__ + "static/media/BTN_Large_Lightbutton.c6fb109e53b8b3b8857abc03e32eb668.svg";
export { ForwardRef as ReactComponent };